const ProductOrderStatusEnum = {
    PAID: 1,
    WAIT_FOR_PAY: 2,
    CANCEL: 3
}
export default ProductOrderStatusEnum